<template>
  <Popup :model-value="modelValue" :popup-header="title" @update:model-value="$emit('update:modelValue', $event)">
    <div v-if="$slots.default" class="mb-16">
      <slot />
    </div>
    <Button
      v-for="button in buttons"
      :id="button.id"
      :key="button.id"
      :value="button.value"
      :href="button.href"
      :to="button.to"
      :variant="button.variant || 'outlined'"
      size="medium"
      :disabled="button.disabled"
      :loading="button.loading"
      class="actions-button"
      @click="onButtonClick(button)"
    />
  </Popup>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import Button from '@/components/button/Button.vue';
import Popup from '@/components/popup/Popup.vue';
import type { ActionButton } from './types';

export default defineComponent({
  name: 'ActionsPopup',
  components: {
    Button,
    Popup,
  },
  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    buttons: {
      type: Array as PropType<ActionButton[]>,
      default: () => [],
    },
  },
  emits: ['update:modelValue', 'action'],
  methods: {
    onButtonClick(button: ActionButton) {
      if (button.onClick) {
        button.onClick();
      }
    },
  },
});
</script>

<style lang="scss" scoped>
.actions-button {
  @apply w-full mb-16;

  &:last-child {
    @apply mb-0;
  }
}
</style>
